module.exports = __webpack_public_path__ + "static/media/usdt_1.8385d02f.svg";